import React from 'react';

import SessionV2 from '../Celebrity/Celebrity';

import './Streamer.css';

function Streamer(props) {
  return (
    <SessionV2
      {...props}
      cdnPreviewTemplate={props.cdnPreviewTemplate || 'facesOnlyHD'}
      showMainVideo={false}
      showConference={false}
      showInteractivityBelowPreview={true}
      className={'streamer'}
      isStarRequired={false}
    />
  );
}

export default Streamer;
